import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	copyIntegrationsTableCopiedTextNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.copy-integrations-table-copied-text-non-final',
		defaultMessage: 'Copied',
		description: 'Transition home chat tools step copy integration table copied text',
	},
	copyIntegrationsTableUnconnectedTextNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.copy-integrations-table-unconnected-text-non-final',
		defaultMessage: 'Unconnected',
		description: 'Transition home chat tools step copy integration table unconnected text',
	},
	givePermissionTextNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.give-permission-text-non-final',
		defaultMessage: 'Give permission',
		description: 'Transition home chat tools step table give permission text',
	},
	copyToJiraNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.copy-to-jira-non-final',
		defaultMessage: 'Copy to Jira',
		description: 'Transition home chat tools step copy to jira',
	},
	slackUnconnectedTooltipNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.slack-unconnected-tooltip-non-final',
		defaultMessage:
			'Connect the Slack workspace to Jira Service Management and then copy the integration.',
		description:
			'Transition home chat tools step copy integrations table slack unconnected tooltip',
	},
	mstUnconnectedTooltipNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.mst-unconnected-tooltip-non-final',
		defaultMessage:
			'Connect the Microsoft tenant to Jira Service Management and then copy the integration.',
		description: 'Transition home chat tools step copy integrations table mst unconnected tooltip',
	},
	slackGivePermissionTooltipNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.slack-give-permission-tooltip-non-final',
		defaultMessage: 'Give permission to create channels and post to channels in Slack.',
		description: 'Transition home chat tools step copy integrations table give permission tooltip',
	},
	mstGivePermissionTooltipNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.mst-give-permission-tooltip-non-final',
		defaultMessage:
			'Give permission to create chats, meetings, and post to channels in Microsoft Teams.',
		description: 'Transition home chat tools step copy integrations table give permission tooltip',
	},
});
